import R from 'ramda'

// Mapping form actions to widget actions

import {
  isHashtagFormTrigger,
  convertHashtagFormTriggerToWidgetTrigger
} from './form-to-widget/hashtag'
import {
  isKeywordFormTrigger,
  convertKeywordFormTriggerToWidgetTrigger
} from './form-to-widget/keyword'
import {
  isLikeFormTrigger,
  convertLikeFormTriggerToWidgetTrigger
} from './form-to-widget/like'
import {
  isLikeOrRetweetFormTrigger,
  convertLikeOrRetweetFormTriggerToWidgetTrigger
} from './form-to-widget/like_or_retweet'
import {
  isMentionFormTrigger,
  convertMentionFormTriggerToWidgetTrigger
} from './form-to-widget/mention'
import {
  isRetweetFormTrigger,
  convertRetweetFormTriggerToWidgetTrigger
} from './form-to-widget/retweet'
import {
  isTimestampFormTrigger,
  convertTimestampFormTriggerToWidgetTrigger
} from '../common-triggers/form-to-widget/timestamp'
import {
  isSpeedThreadExpiryDisplayType,
  convertThreadExpiryToWidget
} from './form-to-widget/speed-thread-expired'

import {
  isLikeOfAnyFormTrigger,
  convertLikeAnyFormToWidgetTrigger
} from './form-to-widget/like_of_any'

// Mapping widget actions to form actions

import {
  isHashtagWidgetTrigger,
  convertHashtagWidgetTriggerToFormTrigger
} from './widget-to-form/hashtag'
import {
  isInitialTweetWidgetTrigger,
  convertInitialTweetWidgetTriggerToFormTrigger
} from './widget-to-form/initial-tweet'
import {
  isKeywordWidgetTrigger,
  convertKeywordWidgetTriggerToFormTrigger
} from './widget-to-form/keyword'
import {
  isLikeWidgetTrigger,
  convertLikeWidgetTriggerToFormTrigger
} from './widget-to-form/like'
import {
  isMentionWidgetTrigger,
  convertMentionWidgetTriggerToFormTrigger
} from './widget-to-form/mention'
import {
  isOwnerTweetWidgetTrigger,
  convertOwnerTweetWidgetTriggerToFormTrigger
} from './widget-to-form/owner-tweet'
import {
  isRetweetWidgetTrigger,
  convertRetweetWidgetTriggerToFormTrigger
} from './widget-to-form/retweet'
import {
  isLikeOrRetweetTrigger,
  convertLikeOrRewtweetWidgetTriggerToFormTrigger
} from './widget-to-form/like_or_retweet'
import {
  isTimestampWidgetTrigger,
  convertTimestampWidgetTriggerToFormTrigger
} from '../common-triggers/widget-to-form/timestamp'
import {
  isSpeedThreadExpiryWidgetType,
  convertSpeedThreadExpiryToForm
} from './widget-to-form/speed-thread-expired'

import {
  isLikeOfAnyWidgetTrigger,
  convertLikeOfAnyWidgetToFormTrigger
} from './widget-to-form/like_of_any'

const mapTwitterFormTriggersToWidgetTriggers = R.map(
  R.cond([
    [isHashtagFormTrigger, convertHashtagFormTriggerToWidgetTrigger],
    [isKeywordFormTrigger, convertKeywordFormTriggerToWidgetTrigger],
    [isLikeFormTrigger, convertLikeFormTriggerToWidgetTrigger],
    [isMentionFormTrigger, convertMentionFormTriggerToWidgetTrigger],
    [isRetweetFormTrigger, convertRetweetFormTriggerToWidgetTrigger],
    [isTimestampFormTrigger, convertTimestampFormTriggerToWidgetTrigger],
    [
      isLikeOrRetweetFormTrigger,
      convertLikeOrRetweetFormTriggerToWidgetTrigger
    ],
    [isSpeedThreadExpiryDisplayType, convertThreadExpiryToWidget],
    [isLikeOfAnyFormTrigger, convertLikeAnyFormToWidgetTrigger],
    [R.T, R.identity]
  ])
)

const filterOutInvalidTwitterWidgetTriggers = R.filter(
  R.complement(R.both(R.propEq('type', 'FROM'), R.propEq('negate', true)))
)

const mapTwitterWidgetTriggersToFormTriggers = R.pipe(
  filterOutInvalidTwitterWidgetTriggers,
  R.map(
    R.cond([
      [isHashtagWidgetTrigger, convertHashtagWidgetTriggerToFormTrigger],
      [
        isInitialTweetWidgetTrigger,
        convertInitialTweetWidgetTriggerToFormTrigger
      ],
      [isKeywordWidgetTrigger, convertKeywordWidgetTriggerToFormTrigger],
      [isLikeWidgetTrigger, convertLikeWidgetTriggerToFormTrigger],
      [isMentionWidgetTrigger, convertMentionWidgetTriggerToFormTrigger],
      [isOwnerTweetWidgetTrigger, convertOwnerTweetWidgetTriggerToFormTrigger],
      [isRetweetWidgetTrigger, convertRetweetWidgetTriggerToFormTrigger],
      [isLikeOrRetweetTrigger, convertLikeOrRewtweetWidgetTriggerToFormTrigger],
      [isTimestampWidgetTrigger, convertTimestampWidgetTriggerToFormTrigger],
      [isSpeedThreadExpiryWidgetType, convertSpeedThreadExpiryToForm],
      [isLikeOfAnyWidgetTrigger, convertLikeOfAnyWidgetToFormTrigger],
      [R.T, R.identity]
    ])
  )
)

export {
  mapTwitterFormTriggersToWidgetTriggers,
  mapTwitterWidgetTriggersToFormTriggers
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/index.js